import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import {
  extractMyJobsUrlParams,
  buildApiQueryParams,
} from '@worker/helpers/my-jobs-helpers';
import { MY_JOBS_PAGE_SIZE } from '@constants/various';

/**
 * Custom hook to manage MyJobs query state from URL parameters.
 * Extracts URL params, calculates current page, and builds API query parameters.
 *
 * @returns Object containing urlParams (filters, pagination, openJobDetails), currentPage, and apiQueryParams
 */
export function useMyJobsQueryState() {
  const [searchParams] = useSearchParams();

  const urlParams = useMemo(
    () => extractMyJobsUrlParams(searchParams),
    [searchParams]
  );

  const currentPage = urlParams.offset
    ? Math.floor(urlParams.offset / MY_JOBS_PAGE_SIZE) + 1
    : 1;

  const apiQueryParams = useMemo(() => {
    const params = buildApiQueryParams(urlParams);
    params.max = MY_JOBS_PAGE_SIZE;
    params.offset = (currentPage - 1) * MY_JOBS_PAGE_SIZE;
    return params;
  }, [urlParams, currentPage]);

  return {
    urlParams,
    currentPage,
    apiQueryParams,
  };
}
